import Type1 from "./tabType1";

export default Type1;
